import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { IconLabelBox } from '../../IconLabelBox';
import { TerminatedIcon as Terminated, TerminatedOutlineIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const TerminatedIcon: FC<Props> = ({ style, variant }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <WbInfoTooltip
      title="The execution has been terminated"
      icon={
        <span>
          {variant === 'reduced' ? (
            <Terminated className={`${classes.icon}`} style={style} />
          ) : (
            <IconLabelBox
              label="Terminated"
              backgroundColor={theme.palette.blueGrey[200]}
              icon={
                <TerminatedOutlineIcon
                  style={style}
                  htmlColor={theme.palette.black}
                />
              }
            />
          )}
        </span>
      }
    />
  );
};
